import React, { ComponentType } from 'react'
import { createRoot } from 'react-dom/client'
import { RetorikFramework } from './components'

export default function renderFramework(RetorikFramework: ComponentType<any>, props: any, element: HTMLElement): void {
  const root = createRoot(element)
  root.render(<RetorikFramework {...props} />)
}

// WebComponent creation
class RetorikFrameworkWebComponent extends HTMLElement {
  constructor() {
    super()
  }

  // Mehod called when the element is connected to the DOM
  connectedCallback() {
    const tenant = this.getAttribute('tenant')
    const prefix = this.getAttribute('prefix')
    const props = JSON.parse(this.getAttribute('props') || '{}')

    if (tenant) {
      const addressData = {
        tenant: tenant,
        prefix: prefix
      }

      this._renderAgent({ ...props, addressData: addressData })
    }
  }

  // React component rendering
  private _renderAgent(props: any) {
    const root = createRoot(this)
    root.render(<RetorikFramework {...props} />)
  }
}

// WebComponent registering in window
window.customElements.define('retorik-framework', RetorikFrameworkWebComponent)
